import { render, staticRenderFns } from "./RayosX.vue?vue&type=template&id=158e53c4&"
import script from "./RayosX.vue?vue&type=script&lang=js&"
export * from "./RayosX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports